import { render, staticRenderFns } from "./lawyer_list.vue?vue&type=template&id=21bffb0c&scoped=true"
import script from "./lawyer_list.vue?vue&type=script&lang=js"
export * from "./lawyer_list.vue?vue&type=script&lang=js"
import style0 from "./lawyer_list.vue?vue&type=style&index=0&id=21bffb0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bffb0c",
  null
  
)

export default component.exports